/**
 * rtSeriesPick.js — правило выбора серии, о которой шлюз выносит вердикт.
 *
 * Вынесено отдельным файлом сознательно: сбор серий завязан на Cornerstone и
 * загрузчики, его без браузера не проверить, а вот САМО РЕШЕНИЕ — какую из
 * открытых серий судить — чистая логика. Именно в ней и сидел дефект 7.0.16
 * (плоский список + выбор середины → при открытых КТ и МРТ судили КТ), поэтому
 * теперь она отделена от браузерной части и покрыта тестом.
 *
 * Браузерных импортов здесь нет и быть не должно.
 */

/**
 * Упорядочить серии: сначала те, что показаны в окнах.
 * Только переупорядочивание — состав списка не меняется.
 * @param {Array<{key:string}>} groups
 * @param {Set<string>|Array<string>} shownKeys ключи томов, привязанных к вьюпортам
 */
export function orderGroups(groups, shownKeys) {
  const list = Array.isArray(groups) ? groups.slice() : [];
  const shown = shownKeys instanceof Set ? shownKeys : new Set(shownKeys || []);
  if (!shown.size) return list;
  // Устойчивая сортировка: показанные — вперёд, взаимный порядок сохраняется.
  return list
    .map((g, i) => ({ g, i, shown: shown.has(String(g.key)) ? 0 : 1 }))
    .sort((a, b) => (a.shown - b.shown) || (a.i - b.i))
    .map(x => x.g);
}

/**
 * Выбрать серию для вердикта: первую МР-серию, до которой удалось дочитать теги.
 *
 * @param {Array} groups серии-кандидаты (уже упорядоченные)
 * @param {(group:any)=>Promise<object|null>} readTags чтение тегов одной серии
 * @param {string} [want='MR'] искомая модальность
 * @returns {Promise<{picked,tags}|{picked,tags,onlyModality}|{noTags:true}|{none:true}>}
 *   none        — кандидатов нет вовсе;
 *   noTags      — кандидаты есть, но теги не прочитались ни у одного;
 *   onlyModality— МР-серии нет; вернули что нашлось, и это НАДО сказать вслух,
 *                 а не выдавать КТ за проверку качества МРТ.
 */
export async function pickSeries(groups, readTags, want = 'MR') {
  const list = Array.isArray(groups) ? groups : [];
  if (!list.length) return { none: true };
  const target = String(want).toUpperCase();
  const fallback = [];
  for (const g of list) {
    let tags = null;
    try { tags = await readTags(g); } catch (e) { tags = null; }
    if (!tags) continue;
    if (String(tags.modality || '').toUpperCase() === target) return { picked: g, tags };
    fallback.push({ picked: g, tags });
  }
  if (fallback.length) {
    return { picked: fallback[0].picked, tags: fallback[0].tags, onlyModality: fallback[0].tags.modality || '—' };
  }
  return { noTags: true };
}

export default { orderGroups, pickSeries };
